import { Capacitor } from "@capacitor/core";

const PRODUCTION_BACKEND_URL = "https://mmj-backend-gxyt.onrender.com";

function normalizeUrl(value) {
  return String(value || "").replace(/\/+$/, "");
}

function readBooleanEnv(value, fallback) {
  if (value === undefined || value === null || value === "") return fallback;
  return ["1", "true", "yes", "on"].includes(String(value).toLowerCase());
}

const configuredBackendUrl = normalizeUrl(process.env.REACT_APP_BACKEND_URL || PRODUCTION_BACKEND_URL);
const isLocalBackendUrl = /^https?:\/\/(127\.0\.0\.1|localhost)(:\d+)?$/i.test(configuredBackendUrl);
const shouldUseProductionBackend = isLocalBackendUrl && (
  process.env.NODE_ENV === "production" || Capacitor.isNativePlatform()
);

export const BACKEND_URL = shouldUseProductionBackend
  ? PRODUCTION_BACKEND_URL
  : configuredBackendUrl;

export const API = `${BACKEND_URL}/api`;

export const FREE_BACKEND_MODE = readBooleanEnv(
  process.env.REACT_APP_FREE_BACKEND_MODE,
  BACKEND_URL.includes(".onrender.com")
);

export const FREE_BACKEND_CONFIG = {
  enabled: FREE_BACKEND_MODE,
  wakeLoopEnabled: FREE_BACKEND_MODE,
  healthPath: "/healthz",
  wakeIntervalMs: 10 * 60 * 1000,
  minWakeGapMs: 60 * 1000,
  wakeTimeoutMs: 15000,
  uploadTimeoutMs: FREE_BACKEND_MODE ? 180000 : 90000,
  networkErrorMessage: FREE_BACKEND_MODE
    ? "Le serveur met du temps a repondre. Sur l'hebergement gratuit, il peut se reveiller apres quelques secondes. Reessayez."
    : "Erreur reseau. Verifiez votre connexion puis reessayez.",
  staleSystemRouteMessage: FREE_BACKEND_MODE
    ? "Route systeme introuvable. Le backend deploye n'est probablement pas encore a jour, ou l'URL backend ne pointe pas vers le bon service."
    : "Route systeme introuvable. Verifiez que le backend deploye est a jour.",
  uploadWaitMessage: FREE_BACKEND_MODE
    ? "Envoi du dossier en cours. Sur mobile, cela peut prendre jusqu'a deux minutes si les photos sont lourdes ou si le serveur se reveille."
    : "Envoi du dossier en cours. Cela peut prendre quelques instants si les photos sont lourdes.",
};
